// Author YuJiaBei
// Date 2023-05-30 09:48:46

class SithMesPrdProjectInfo {
constructor({
        id = null,
        projectCode = '',
        projectName = '',
        prpIdMachineType = '',
        prpIdMachineTypeName = '',
        prpIdMachineTypeA = '',
        prpIdMachineTypeAName = '',
        machine1 = '',
        wbsNumber = '',
        salesOrderNumber = '',
                network = '',
                sparePartsNetwork = '',
                sagProjectCode = '',
                startTime = '',
                endTime = '',
                deliveryMethod = '',
                machine2 = '',
                pm = '',
                cpm = '',
                om = '',
                customerId = '',
                planStatus = '',
                status = '',
                engCoreCompressor = '',
                gyyCoreCompressor = '',
                engSteamTurbineA = '',
                gyySteamTurbineA = '',
                engSteamTurbineB = '',
                gyySteamTurbineB = '',
                engSteamTurbineC = '',
                gyySteamTurbineC = '',
        engSystemA = '',
        gyySystemA = '',
        engSystemB = '',
        gyySystemB = '',
        engIc = '',
        gyyIc = '',
        nvaOrEvaOrOther = '',
        sfdcNumber = '',
        oldSaleOrderNumber = '',
        kamLockDate = '',
        zzbOrderDate = '',
        zzbActualDeliverDate = '',
        zzbClause = '',
        actualDeliverDate = '',
        revision = '',
        toolInfo = '',
        baselineAStartTime = '',
        baselineAEndTime = '',
        baselineBStartTime = '',
        baselineBEndTime = '',
        omForecastStartTime = '',
        omForecastEndTime = '',
        ppForecastStartTime = '',
        ppForecastEndTime = '',
        actualStartTime = '',
        actualEndTime = '',
        lastStartTime = '',
        lastEndTime = '',
        baselineStartDeviation = '',
        baselineEndDeviation = '',
        omPpStartDeviation = '',
        omPpEndDeviation = '',
        omAclStartDeviation = '',
        omAclEndDeviation = '',
        baseActualStartDev = '',
        baseActualEndDev = '',
        machine3 = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectCode = projectCode;
    this.projectName = projectName;
    this.prpIdMachineType = prpIdMachineType;
    this.prpIdMachineTypeName = prpIdMachineTypeName;
    this.prpIdMachineTypeA = prpIdMachineTypeA;
    this.prpIdMachineTypeAName = prpIdMachineTypeAName;
    this.machine1 = machine1;
    this.wbsNumber = wbsNumber;
    this.salesOrderNumber = salesOrderNumber;
    this.network = network;
    this.sparePartsNetwork = sparePartsNetwork;
    this.sagProjectCode = sagProjectCode;
    this.startTime = startTime;
    this.endTime = endTime;
    this.deliveryMethod = deliveryMethod;
    this.machine2 = machine2;
    this.pm = pm;
    this.cpm = cpm;
    this.om = om;
    this.customerId = customerId;
    this.planStatus = planStatus;
    this.status = status;
    this.engCoreCompressor = engCoreCompressor;
    this.gyyCoreCompressor = gyyCoreCompressor;
    this.engSteamTurbineA = engSteamTurbineA;
    this.gyySteamTurbineA = gyySteamTurbineA;
    this.engSteamTurbineB = engSteamTurbineB;
    this.gyySteamTurbineB = gyySteamTurbineB;
    this.engSteamTurbineC = engSteamTurbineC;
    this.gyySteamTurbineC = gyySteamTurbineC;
    this.engSystemA = engSystemA;
    this.gyySystemA = gyySystemA;
    this.engSystemB = engSystemB;
    this.gyySystemB = gyySystemB;
    this.engIc = engIc;
    this.gyyIc = gyyIc;
    this.nvaOrEvaOrOther = nvaOrEvaOrOther;
    this.sfdcNumber = sfdcNumber;
    this.oldSaleOrderNumber = oldSaleOrderNumber;
    this.kamLockDate = kamLockDate;
    this.zzbOrderDate = zzbOrderDate;
    this.zzbActualDeliverDate = zzbActualDeliverDate;
    this.zzbClause = zzbClause;
    this.actualDeliverDate = actualDeliverDate;
    this.revision = revision;
    this.toolInfo = toolInfo;
    this.baselineAStartTime = baselineAStartTime;
    this.baselineAEndTime = baselineAEndTime;
    this.baselineBStartTime = baselineBStartTime;
    this.baselineBEndTime = baselineBEndTime;
    this.omForecastStartTime = omForecastStartTime;
    this.omForecastEndTime = omForecastEndTime;
    this.ppForecastStartTime = ppForecastStartTime;
    this.ppForecastEndTime = ppForecastEndTime;
    this.actualStartTime = actualStartTime;
    this.actualEndTime = actualEndTime;
    this.lastStartTime = lastStartTime;
    this.lastEndTime = lastEndTime;
    this.baselineStartDeviation = baselineStartDeviation;
    this.baselineEndDeviation = baselineEndDeviation;
    this.omPpStartDeviation = omPpStartDeviation;
    this.omPpEndDeviation = omPpEndDeviation;
    this.omAclStartDeviation = omAclStartDeviation;
    this.omAclEndDeviation = omAclEndDeviation;
    this.baseActualStartDev = baseActualStartDev;
    this.baseActualEndDev = baseActualEndDev;
    this.machine3 = machine3;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdProjectInfo();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.id',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.projectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.projectName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machineTypeName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.machineTypeName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machineTypeAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.machineTypeAName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.machine1',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.wbsNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'salesOrderNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.salesOrderNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'salesOrderItem',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.salesOrderItem',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.network',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sparePartsNetwork',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.sparePartsNetwork',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sagProjectCode',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.sagProjectCode',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.startTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.endTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deliveryMethod',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.deliveryMethod',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine2',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.machine2',
        sortable: true,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pm',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.pm',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pmName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.pmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cpm',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.cpm',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'cpmName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.cpmName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'om',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.om',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
            key: 'statusTranslate',
            label: 'label.sith.prd.sithMesPrdProjectInfo.grid.statusTranslate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
        key: 'engCoreCompressor',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engCoreCompressor',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engCoreCompressorName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engCoreCompressorName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyyCoreCompressor',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyyCoreCompressor',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyyCoreCompressorName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyyCoreCompressorName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineA',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineAName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineA',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineAName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineB',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineBName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineBName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineB',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineBName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineBName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineC',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineC',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSteamTurbineCName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSteamTurbineCName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineC',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineC',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySteamTurbineCName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySteamTurbineCName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSystemA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSystemA',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSystemAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSystemAName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySystemA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySystemA',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySystemAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySystemAName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSystemB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSystemB',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engSystemBName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engSystemBName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySystemB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySystemB',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyySystemBName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyySystemBName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engIc',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engIc',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engIcName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.engIcName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyyIc',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyyIc',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'gyyIcName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.gyyIcName',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'nvaOrEvaOrOther',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.nvaOrEvaOrOther',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '1', text: 'MVA'},
                {value: '2', text: 'EVA'},
                {value: '3', text: 'OTHER'}
            ]
        }
        },
        {
        key: 'sfdcNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.sfdcNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldSaleOrderNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.oldSaleOrderNumber',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'kamLockDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.kamLockDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbOrderDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.zzbOrderDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbActualDeliverDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.zzbActualDeliverDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbClause',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.zzbClause',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualDeliverDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.actualDeliverDate',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolInfo',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.toolInfo',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'planStatus',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.planStatus',
        sortable: true,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , options: [
                {value: '80', text: '已完成'},
                {value: '70', text: '挂起'},
                {value: '60', text: '生产中'},
                {value: '50', text: '冻结'},
                {value: '40', text: '项目计划'},
                {value: '30', text: '主计划'},
                {value: '20', text: '草拟版'},
                {value: '10', text: '新建'}
            ]
        }
        },
        {
        key: 'baselineAStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineAStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineAEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineAEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineBStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineBEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omForecastStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omForecastEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.ppForecastStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.ppForecastEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.actualStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.actualEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastStartTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.lastStartTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastEndTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.lastEndTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineStartDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baselineEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omPpStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omPpStartDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omPpEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omPpEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omAclStartDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omAclStartDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omAclEndDeviation',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.omAclEndDeviation',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baseActualStartDev',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baseActualStartDev',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baseActualEndDev',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.baseActualEndDev',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine3',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.machine3',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'revision',
        label: 'label.sith.prd.sithMesPrdProjectInfo.grid.revision',
        sortable: true,
            isDetail: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter: '',
    idListFilter: [],
    projectCodeFilter: '',
    projectCodeEqFilter: '',
    projectNameFilter: '',
    prpIdMachineTypeNameFilter: '',
    prpIdMachineTypeANameFilter: '',
    machine1Filter: '',
    wbsNumberFilter: '',
    salesOrderNumberFilter: '',
    salesOrderItemFilter: '',
    networkFilter: '',
    networkInFilter: [],
    sparePartsNetworkFilter: '',
    sagProjectCodeFilter: '',
    startTimeRteFilter: '',
    startTimeLteFilter: '',
    endTimeRteFilter: '',
    endTimeLteFilter: '',
    deliveryMethodFilter: '',
    machine2Filter: '',
    pmFilter: '',
    cpmFilter: '',
    omFilter : '',
    statusFilter : '',
    engCoreCompressorFilter : '',
    gyyCoreCompressorFilter : '',
    engSteamTurbineAFilter : '',
    gyySteamTurbineAFilter : '',
    engSteamTurbineBFilter : '',
    gyySteamTurbineBFilter : '',
    engSteamTurbineCFilter : '',
    gyySteamTurbineCFilter : '',
    engSystemAFilter : '',
    gyySystemAFilter : '',
    engSystemBFilter : '',
    gyySystemBFilter : '',
    engIcFilter : '',
    gyyIcFilter : '',
    nvaOrEvaOrOtherFilter : '',
    sfdcNumberFilter : '',
    oldSaleOrderNumberFilter : '',
    kamLockDateRteFilter : '',
    kamLockDateLteFilter : '',
    zzbOrderDateRteFilter : '',
    zzbOrderDateLteFilter : '',
    zzbActualDeliverDateRteFilter : '',
    zzbActualDeliverDateLteFilter : '',
    zzbClauseFilter : '',
    actualDeliverDateRteFilter : '',
    actualDeliverDateLteFilter : '',
    toolInfoFilter : '',
    planStatusFilter : '',
    baselineAStartTimeRteFilter : '',
    baselineAStartTimeLteFilter : '',
    baselineAEndTimeRteFilter : '',
    baselineAEndTimeLteFilter : '',
    baselineBStartTimeRteFilter : '',
    baselineBStartTimeLteFilter : '',
    baselineBEndTimeRteFilter : '',
    baselineBEndTimeLteFilter : '',
    omForecastStartTimeRteFilter : '',
    omForecastStartTimeLteFilter : '',
    omForecastEndTimeRteFilter : '',
    omForecastEndTimeLteFilter : '',
    ppForecastStartTimeRteFilter : '',
    ppForecastStartTimeLteFilter : '',
    ppForecastEndTimeRteFilter : '',
    ppForecastEndTimeLteFilter : '',
    actualStartTimeRteFilter : '',
    actualStartTimeLteFilter : '',
    actualEndTimeRteFilter : '',
    actualEndTimeLteFilter : '',
    lastStartTimeRteFilter : '',
    lastStartTimeLteFilter : '',
    lastEndTimeRteFilter : '',
    lastEndTimeLteFilter : '',
    baselineStartDeviationFilter : '',
    baselineEndDeviationFilter : '',
    omPpStartDeviationFilter : '',
    omPpEndDeviationFilter : '',
    omAclStartDeviationFilter : '',
    omAclEndDeviationFilter : '',
    baseActualStartDevFilter : '',
    baseActualEndDevFilter : '',
    revisionFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'prpIdMachineTypeNameFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.prpIdMachineTypeName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'prpIdMachineTypeANameFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.prpIdMachineTypeAName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1Filter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.machine1',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.wbsNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'salesOrderNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.salesOrderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'salesOrderItemFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.salesOrderItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'networkFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.network',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sparePartsNetworkFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.sparePartsNetwork',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sagProjectCodeFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.sagProjectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.startTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.startTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.endTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.endTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deliveryMethodFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.deliveryMethod',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine2Filter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.machine2',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pmFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.pm',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'cpmFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.cpm',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'omFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.om',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.status',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '商务未释放'},
                {value: '2', text: '设计'},
                {value: '3', text: '采购'},
                {value: '4', text: '生产'},
                {value: '5', text: '暂停'},
                {value: '6', text: '寄存'},
                {value: '7', text: '待发货'},
                {value: '8', text: '已发出'}
            ]
        }
        },
        {
        key: 'engCoreCompressorFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engCoreCompressor',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyyCoreCompressorFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyyCoreCompressor',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineAFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engSteamTurbineA',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineAFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyySteamTurbineA',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineBFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engSteamTurbineB',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineBFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyySteamTurbineB',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineCFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engSteamTurbineC',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineCFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyySteamTurbineC',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSystemAFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engSystemA',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySystemAFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyySystemA',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSystemBFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engSystemB',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySystemBFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyySystemB',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engIcFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.engIc',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyyIcFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.gyyIc',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'nvaOrEvaOrOtherFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.nvaOrEvaOrOther',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: 'MVA'},
                {value: '2', text: 'EVA'},
                {value: '3', text: 'OTHER'}
            ]
        }
        },
        {
        key: 'sfdcNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.sfdcNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldSaleOrderNumberFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.oldSaleOrderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'kamLockDateRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.kamLockDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'kamLockDateLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.kamLockDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbOrderDateRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.zzbOrderDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbOrderDateLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.zzbOrderDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbActualDeliverDateRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.zzbActualDeliverDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbActualDeliverDateLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.zzbActualDeliverDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbClauseFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.zzbClause',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualDeliverDateRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualDeliverDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualDeliverDateLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualDeliverDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolInfoFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.toolInfo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'planStatusFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.planStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '80', text: '已完成'},
                {value: '70', text: '挂起'},
                {value: '60', text: '生产中'},
                {value: '50', text: '冻结'},
                {value: '40', text: '项目计划'},
                {value: '30', text: '主计划'},
                {value: '20', text: '草拟版'},
                {value: '10', text: '新建'}
            ]
        }
        },
        {
        key: 'baselineAStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineAStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineAStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineAStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineAEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineAEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineAEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineAEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineBStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineBStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineBEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineBEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineBEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omForecastStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omForecastStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.ppForecastStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.ppForecastStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.ppForecastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'ppForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.ppForecastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.actualEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastStartTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.lastStartTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastStartTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.lastStartTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.lastEndTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.lastEndTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineStartDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineStartDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baselineEndDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baselineEndDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omPpStartDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omPpStartDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omPpEndDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omPpEndDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omAclStartDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omAclStartDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'omAclEndDeviationFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.omAclEndDeviation',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baseActualStartDevFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baseActualStartDev',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'baseActualEndDevFilter',
        label: 'label.sith.prd.sithMesPrdProjectInfo.filter.baseActualEndDev',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
        },
];


    const entityFormConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.projectName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'prpIdMachineTypeName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.prpIdMachineTypeName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstMachineType'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"prpIdMachineType":"id"}'
        }
        },
        {
        key: 'prpIdMachineTypeAName',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.prpIdMachineTypeAName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstMachineType'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"prpIdMachineTypeA":"id"}'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.machine1',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'salesOrderNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.salesOrderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'network',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.network',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sparePartsNetwork',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.sparePartsNetwork',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sagProjectCode',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.sagProjectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deliveryMethod',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.deliveryMethod',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine2',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.machine2',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pm',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.pm',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'cpm',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.cpm',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'om',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.om',
            sortable: true,
            disabled: false,
            form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                , entity: 'emAclUser'
                , correspondingField: 'loginName'
            }
        },
        {
            key: 'customerId',
            label: 'label.sith.prd.sithMesPrdProjectInfo.entity.customerId',
            sortable: true,
            disabled: false,
            form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                , entity: 'sithMesCustomer'
                , correspondingField: 'id'
            }
        },
        {
            key: 'status',
            label: 'label.sith.prd.sithMesPrdProjectInfo.entity.status',
            sortable: true,
            disabled: false,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , showLabelSelectOne: true
                , options: [
                    {value: '1', text: '商务未释放'},
                    {value: '2', text: '设计'},
                    {value: '3', text: '采购'},
                    {value: '4', text: '生产'},
                    {value: '5', text: '暂停'},
                    {value: '6', text: '寄存'},
                    {value: '7', text: '待发货'},
                    {value: '8', text: '已发出'}
                ]
            }
        },
        {
        key: 'engCoreCompressor',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engCoreCompressor',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyyCoreCompressor',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyyCoreCompressor',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engSteamTurbineA',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyySteamTurbineA',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engSteamTurbineB',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyySteamTurbineB',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSteamTurbineC',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engSteamTurbineC',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySteamTurbineC',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyySteamTurbineC',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSystemA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engSystemA',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySystemA',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyySystemA',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engSystemB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engSystemB',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyySystemB',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyySystemB',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'engIc',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.engIc',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'gyyIc',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.gyyIc',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
        },
        {
        key: 'nvaOrEvaOrOther',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.nvaOrEvaOrOther',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'sfdcNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.sfdcNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldSaleOrderNumber',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.oldSaleOrderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'kamLockDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.kamLockDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbOrderDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.zzbOrderDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbActualDeliverDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.zzbActualDeliverDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'zzbClause',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.zzbClause',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'actualDeliverDate',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.actualDeliverDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolInfo',
        label: 'label.sith.prd.sithMesPrdProjectInfo.entity.toolInfo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
        },
]

export {SithMesPrdProjectInfo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
